var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#4F5A99"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12146_15885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38379 11.0005C8.38379 12.4429 9.55735 13.6164 10.9999 13.6164C12.4424 13.6164 13.6158 12.4429 13.6158 11.0005C13.6158 9.55797 12.4423 8.3844 10.9999 8.3844C9.55735 8.38437 8.38379 9.55794 8.38379 11.0005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.024 7.54727C17.0444 7.51143 17.044 7.4674 17.0229 7.43191C16.4136 6.40564 15.5464 5.54598 14.5152 4.94593C13.4524 4.32741 12.2369 4.00049 11.0002 4.00049C8.86005 4.00049 6.86554 4.96094 5.52805 6.63555C5.49854 6.67246 5.49469 6.72362 5.51831 6.76453L7.48887 10.1776C7.50951 10.2133 7.54763 10.2349 7.58821 10.2349C7.59335 10.2349 7.59857 10.2346 7.60376 10.2339C7.64995 10.2276 7.68771 10.194 7.69939 10.1488C8.08794 8.64332 9.44531 7.59184 11.0002 7.59184C11.0967 7.59184 11.1964 7.59625 11.2965 7.60478C11.2998 7.6051 11.3031 7.60524 11.3063 7.60524H16.9243C16.9656 7.6053 17.0036 7.58318 17.024 7.54727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0344 14.3249C12.0059 14.288 11.958 14.2722 11.9129 14.2847C11.6165 14.3672 11.3094 14.409 11 14.409C9.68534 14.409 8.47366 13.638 7.91308 12.4447C7.91171 12.4418 7.91018 12.4389 7.90857 12.4361L5.09755 7.56738C5.07707 7.5318 5.03917 7.51001 4.99818 7.51001C4.99799 7.51001 4.99777 7.51001 4.99758 7.51001C4.95637 7.51023 4.91839 7.53251 4.89821 7.56839C4.31062 8.61103 4 9.79783 4 11.0005C4 12.6876 4.60864 14.3172 5.71382 15.5892C6.80804 16.8485 8.31443 17.6773 9.95563 17.9229C9.96132 17.9237 9.96701 17.9241 9.97267 17.9241C10.0132 17.9241 10.0513 17.9025 10.072 17.8667L12.0431 14.4527C12.0664 14.4122 12.0629 14.3618 12.0344 14.3249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4113 8.37103H13.465C13.4183 8.37103 13.3763 8.39925 13.3588 8.4424C13.3411 8.48555 13.3514 8.53512 13.3846 8.56772C14.0449 9.21502 14.4086 10.079 14.4086 11.0005C14.4086 11.6981 14.1981 12.3695 13.7998 12.942C13.798 12.9447 13.7963 12.9474 13.7947 12.9502L10.9788 17.8274C10.9581 17.8631 10.9583 17.9071 10.9791 17.9427C10.9997 17.978 11.0374 17.9995 11.0781 17.9995C11.0786 17.9995 11.079 17.9995 11.0794 17.9995C12.9325 17.9789 14.6714 17.2416 15.9757 15.9238C17.2811 14.6048 18 12.8563 18 11.0005C18 10.1184 17.8379 9.25828 17.5181 8.44388C17.5009 8.39991 17.4585 8.37103 17.4113 8.37103Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12146_15885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/Edge.6939e2e453b9be1f8b754f8bb67e008b.svg";
export { ForwardRef as ReactComponent };